module.exports = __webpack_public_path__ + "static/img/jc.2017a623.png";